import dayjs, { Dayjs } from 'dayjs';

export const formatDate = (
  date?: string,
  config?: { timeOnly?: boolean; withTime?: boolean },
): string => {
  if (!date) {
    return ' - ';
  }
  if (config?.timeOnly) {
    return dayjs(date).format('HH:mm');
  }
  if (config?.withTime) {
    return dayjs(date).format('YYYY-MM-DD HH:mm');
  }
  return dayjs(date).format('YYYY-MM-DD');
};

export const formatDateJs = (date: Dayjs, config?: { withTime?: boolean }): string => {
  return formatDate(date.toISOString(), config);
};

export function formatDateToBackend(date: Dayjs): string;
export function formatDateToBackend(date?: Dayjs | null): string | undefined;
export function formatDateToBackend(date?: Dayjs | null) {
  if (!date) {
    return undefined;
  }
  return date.format('YYYY-MM-DD');
}
